import { AppNotificationType } from '@deltager/organizers/admin/shared/models/AppNotificationType';
import { Action } from '@ngrx/store';

export enum BookingEventSetupUIActionTypes {
  ShowNotification = '[Booking event setup UI] Show confirmation',
  ShowSpinner = '[Booing event setup UI] Show spinner',
  HideSpinner = '[Booking event setup UI] Hide spinner',
}

export class BookingShowNotificationAction implements Action {
  readonly type = BookingEventSetupUIActionTypes.ShowNotification;

  constructor(public payload: { notificationType: AppNotificationType; message: string }) {}
}

export class BookingShowSpinnerAction implements Action {
  readonly type = BookingEventSetupUIActionTypes.ShowSpinner;
}

export class BookingHideSpinnerAction implements Action {
  readonly type = BookingEventSetupUIActionTypes.HideSpinner;
}
